import { Activity, Baby, Bone, Brain, Eye, FlaskConical, HeartPulse, Microscope, ScanLine, Stethoscope } from "lucide-react";

const ICONS = { Activity, Baby, Bone, Brain, Eye, FlaskConical, HeartPulse, Microscope, ScanLine, Stethoscope };

export const ServiceIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = ICONS[name] || Stethoscope;
  return <Icon className={className} />;
};
